import "./App.css";
import { Button } from "@mui/material";

import finals2026 from "./finals2026-hero.jpg";
import LazyLoad from "react-lazyload";
import logo from "./irofullpng.webp";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import OpenInBrowserIcon from "@mui/icons-material/OpenInBrowser";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import QuizIcon from "@mui/icons-material/Quiz";
import ScienceIcon from "@mui/icons-material/Science";
import DescriptionIcon from "@mui/icons-material/Description";
import { useState, useEffect } from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import BoardofAdvisors from "./pages/BoardofAdvisors";

import Partners from "./components/partners";
import Seo from "./components/Seo";
import InterestForm from "./components/InterestForm";

function Home() {
  // eslint-disable-next-line no-unused-vars
  const [pageLoad1, setPageLoad1] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [pageLoad2, setPageLoad2] = useState(false);

  // Removed useInView hooks that were causing lint errors
  // eslint-disable-next-line no-unused-vars
  const ref1 = null;
  // eslint-disable-next-line no-unused-vars
  const ref2 = null;
  // eslint-disable-next-line no-unused-vars
  const inView1 = false;
  // eslint-disable-next-line no-unused-vars
  const inView2 = false;

  useEffect(() => {
    if (!pageLoad1 && inView1) {
      setPageLoad1(true);
      createIframe(".video-responsive1");
    }
  }, [inView1, pageLoad1]);

  useEffect(() => {
    if (!pageLoad2 && inView2) {
      setPageLoad2(true);
      createIframe(".video-responsive2");
    }
  }, [inView2, pageLoad2]);

  const createIframe = (selector) => {
    let iframe = document.createElement("iframe");
    iframe.setAttribute(
      "src",
      "https://www.youtube.com/embed/LmKxVI8i3iU?si=REndfM9Y0Jy1sEI&autoplay=1&mute=1",
    );
    iframe.setAttribute("frameBorder", "0");
    iframe.setAttribute(
      "allow",
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    );
    iframe.setAttribute("allowFullScreen", "");
    iframe.setAttribute("width", "853");
    iframe.setAttribute("height", "480");

    let videoResponsiveElement = document.querySelector(selector);
    if (videoResponsiveElement) {
      videoResponsiveElement.appendChild(iframe);
    } else {
      console.error(`Element with selector '${selector}' not found.`);
    }
  };

  useEffect(() => {
    AOS.init({ duration: 2000 }); //might need to be AOS
  }, []);

  return (
    <div className="App">
      <Seo
        path="/"
        description="The International Research Olympiad (IRO) is the premier global STEM research competition for students aged 13–18. View the 2026 winners, claim your certificate, and explore past exams and practice papers."
      />
      <div className="container">
        {/* Hero Section */}
        <div
          className="container"
          style={{ paddingTop: "80px", paddingBottom: "40px" }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "40px",
            }}
          >
            {/* Left Content */}
            <div style={{ flex: "1", minWidth: "300px" }}>
              <h1
                style={{
                  fontSize: "clamp(2.5rem, 5vw, 3.5rem)",
                  fontWeight: "700",
                  color: "#1a1a2e",
                  letterSpacing: "-0.03em",
                  lineHeight: "1.1",
                  marginBottom: "24px",
                }}
              >
                International Research Olympiad
              </h1>
              <p
                style={{
                  fontSize: "1.15rem",
                  color: "#555",
                  lineHeight: "1.7",
                  marginBottom: "32px",
                  maxWidth: "540px",
                }}
              >
                A premier STEM competition testing science research ability and
                developing both critical thinking and analytical skills. Students
                from over 89 countries have taken part in the IRO. We have created
                the largest global community of young students interested in
                research.
              </p>

              {/* CTA Cards with Eligibility */}
              <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                {/* Register Card */}
                <div
                  style={{
                    flex: "1",
                    minWidth: "280px",
                    backgroundColor: "#fff",
                    borderRadius: "16px",
                    padding: "28px",
                    boxShadow: "0 4px 20px rgba(0, 77, 153, 0.08)",
                    border: "2px solid #004d99",
                  }}
                >
                  {/* Registration Card - commented out (registrations ended) */}
                {/* <Button
                    variant="contained"
                    href="/registration-and-eligibility"
                    fullWidth
                    sx={{
                      py: 1.5,
                      borderRadius: "10px",
                      textTransform: "none",
                      fontSize: "1rem",
                      fontWeight: "600",
                      backgroundColor: "#004d99",
                      boxShadow: "0 4px 14px rgba(0, 77, 153, 0.3)",
                      marginBottom: "20px",
                      "&:hover": {
                        backgroundColor: "#003d7a",
                        boxShadow: "0 6px 20px rgba(0, 77, 153, 0.4)",
                      },
                    }}
                  >
                    Register for IRO 2026
                  </Button>
                  <p
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: "600",
                      color: "#004d99",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      marginBottom: "12px",
                    }}
                  >
                    Who Can Register
                  </p>
                  <ul
                    style={{
                      fontSize: "0.85rem",
                      color: "#555",
                      paddingLeft: "18px",
                      margin: 0,
                      lineHeight: "1.7",
                    }}
                  >
                    <li>Students in Grades 6–12 (including homeschoolers)</li>
                    <li>No prior research experience required</li>
                    <li>
                      Fee waivers available for students who demonstrate
                      financial need
                    </li>
                    <li>All past participants are welcome to apply</li>
                  </ul> */}

                  {/* Ambassador Card */}
                  <Button
                    variant="contained"
                    href="/forms/student-ambassador"
                    fullWidth
                    sx={{
                      py: 1.5,
                      borderRadius: "10px",
                      textTransform: "none",
                      fontSize: "1rem",
                      fontWeight: "600",
                      backgroundColor: "#004d99",
                      boxShadow: "0 4px 14px rgba(0, 77, 153, 0.3)",
                      marginBottom: "20px",
                      "&:hover": {
                        backgroundColor: "#003d7a",
                        boxShadow: "0 6px 20px rgba(0, 77, 153, 0.4)",
                      },
                    }}
                  >
                    Become an Ambassador
                  </Button>
                  <p
                    style={{
                      fontSize: "0.85rem",
                      color: "#555",
                      margin: 0,
                      lineHeight: "1.6",
                    }}
                  >
                    Ambassador applications are reviewed on a rolling basis, and
                    students can expect to hear back within a few weeks.
                  </p>
                </div>
              </div>

            </div>

            {/* Right Content - Logo */}
            <div
              className="mainlscreen"
              style={{ flex: "0 0 auto" }}
              data-aos="fade-up"
            >
              <LazyLoad height={200} once offset={100}>
                <img
                  src={logo}
                  style={{ width: "320px", height: "auto" }}
                  alt="International Research Olympiad Logo"
                />
              </LazyLoad>
            </div>
          </div>
        </div>

        {/* Register interest in future IRO updates */}
        <InterestForm />

        {/* Competition Format Section */}
        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "80px 0",
            marginTop: "60px",
          }}
        >
          <div className="container">
            <div data-aos="fade-up">
              <p className="comptitle" style={{ textAlign: "center" }}>
                Competition Format
              </p>
              <p
                className="lowertitle"
                style={{
                  textAlign: "center",
                  maxWidth: "600px",
                  margin: "0 auto 30px auto",
                }}
              >
                Four stages designed to identify and celebrate the brightest
                young research minds from around the world.
              </p>

              {/* Important Information Box */}
              <div
                style={{
                  background:
                    "linear-gradient(135deg, rgba(0, 77, 153, 0.05) 0%, rgba(0, 77, 153, 0.02) 100%)",
                  borderRadius: "16px",
                  padding: "28px 32px",
                  marginBottom: "40px",
                  maxWidth: "800px",
                  margin: "0 auto 40px auto",
                  border: "1px solid rgba(0, 77, 153, 0.1)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "16px",
                  }}
                >
                  <InfoOutlinedIcon
                    style={{ fontSize: "22px", color: "#004d99" }}
                  />
                  <h4
                    style={{
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      color: "#1a1a2e",
                      margin: 0,
                    }}
                  >
                    How the Competition Works
                  </h4>
                </div>
                <p
                  style={{
                    fontSize: "0.95rem",
                    color: "#555",
                    lineHeight: "1.7",
                    margin: 0,
                  }}
                >
                  The IRO runs in four stages each year, beginning with the
                  online ‘Opens’ round and culminating in the in-person Finals.
                  The 2026 cycle is now complete — view the results in the{" "}
                  <a
                    href="/winners"
                    style={{ color: "#004d99", fontWeight: "600" }}
                  >
                    Winners Hub
                  </a>
                  . Dates for the next cycle will be announced here.
                </p>
              </div>

              {/* Timeline Cards */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                  gap: "20px",
                  maxWidth: "1100px",
                  margin: "0 auto",
                }}
              >
                {/* Card 1: Registration */}
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "16px",
                    padding: "32px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                    border: "1px solid #e8eef3",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      height: "4px",
                      background:
                        "linear-gradient(90deg, #004d99 0%, #0066cc 100%)",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "56px",
                      height: "56px",
                      borderRadius: "12px",
                      background:
                        "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <HowToRegIcon style={{ fontSize: "28px", color: "#fff" }} />
                  </div>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#004d99",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      marginBottom: "8px",
                    }}
                  >
                    Step 1
                  </p>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      color: "#1a1a2e",
                      marginBottom: "8px",
                    }}
                  >
                    Registration
                  </h3>
                  <p
                    style={{
                      fontSize: "0.95rem",
                      fontWeight: "600",
                      color: "#004d99",
                      marginBottom: "16px",
                    }}
                  >
                    Online • Open to all eligible students
                  </p>
                  <p
                    style={{
                      fontSize: "0.95rem",
                      color: "#555",
                      lineHeight: "1.6",
                      margin: 0,
                    }}
                  >
                    Students register online to take part in the IRO. After
                    registering, each student is issued a unique exam login.
                    Once registration closes, students receive their login
                    details and go on to compete in the Opens round.
                  </p>
                </div>

                {/* Card 2: Opens */}
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "16px",
                    padding: "32px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                    border: "1px solid #e8eef3",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      height: "4px",
                      background:
                        "linear-gradient(90deg, #004d99 0%, #0066cc 100%)",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "56px",
                      height: "56px",
                      borderRadius: "12px",
                      background:
                        "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <OpenInBrowserIcon
                      style={{ fontSize: "28px", color: "#fff" }}
                    />
                  </div>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#004d99",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      marginBottom: "8px",
                    }}
                  >
                    Step 2
                  </p>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      color: "#1a1a2e",
                      marginBottom: "8px",
                    }}
                  >
                    Opens
                  </h3>
                  <p
                    style={{
                      fontSize: "0.95rem",
                      fontWeight: "600",
                      color: "#004d99",
                      marginBottom: "16px",
                    }}
                  >
                    Online • All registrants
                  </p>
                  <p
                    style={{
                      fontSize: "0.95rem",
                      color: "#555",
                      lineHeight: "1.6",
                      margin: 0,
                    }}
                  >
                    The "Opens" round is a comprehensive assessment,
                    encompassing diverse elements such as analyzing research
                    papers, interpreting scientific data, and tackling question
                    formation and inquiry. This stage aims to test participants'
                    analytical skills and critical thinking.
                  </p>
                </div>

                {/* Card 3: Semifinals */}
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "16px",
                    padding: "32px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                    border: "1px solid #e8eef3",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      height: "4px",
                      background:
                        "linear-gradient(90deg, #004d99 0%, #0066cc 100%)",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "56px",
                      height: "56px",
                      borderRadius: "12px",
                      background:
                        "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <MilitaryTechIcon
                      style={{ fontSize: "28px", color: "#fff" }}
                    />
                  </div>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#004d99",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      marginBottom: "8px",
                    }}
                  >
                    Step 3
                  </p>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      color: "#1a1a2e",
                      marginBottom: "8px",
                    }}
                  >
                    Semifinals
                  </h3>
                  <p
                    style={{
                      fontSize: "0.95rem",
                      fontWeight: "600",
                      color: "#004d99",
                      marginBottom: "16px",
                    }}
                  >
                    Online • Top 10%
                  </p>
                  <p
                    style={{
                      fontSize: "0.95rem",
                      color: "#555",
                      lineHeight: "1.6",
                      margin: 0,
                    }}
                  >
                    From the Open examinations, the top 10% of participants will
                    advance to the semifinals. The semifinals elevate the
                    challenge of introducing free response questions judged by
                    qualified researchers delving deeper into participants'
                    ability to articulate and apply their understanding of
                    scientific concepts.
                  </p>
                </div>

                {/* Card 4: Finals */}
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "16px",
                    padding: "32px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                    border: "1px solid #e8eef3",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      height: "4px",
                      background:
                        "linear-gradient(90deg, #004d99 0%, #0066cc 100%)",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "56px",
                      height: "56px",
                      borderRadius: "12px",
                      background:
                        "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <EmojiEventsIcon
                      style={{ fontSize: "28px", color: "#fff" }}
                    />
                  </div>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#004d99",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      marginBottom: "8px",
                    }}
                  >
                    Step 4
                  </p>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      color: "#1a1a2e",
                      marginBottom: "8px",
                    }}
                  >
                    Finals
                  </h3>
                  <p
                    style={{
                      fontSize: "0.95rem",
                      fontWeight: "600",
                      color: "#004d99",
                      marginBottom: "16px",
                    }}
                  >
                    In-Person Finals • Top 12
                  </p>
                  <p
                    style={{
                      fontSize: "0.95rem",
                      color: "#555",
                      lineHeight: "1.6",
                      margin: 0,
                    }}
                  >
                    The pinnacle of the competition is the finals, where the top
                    12 participants will engage in intense competition for the
                    coveted gold, silver, and bronze medals in the IRO.
                    Additional sponsor prizes, media opportunities, and
                    recognition will be awarded.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Resources Section */}
        <div className="container">
          <div className="row rowpad1" data-aos="fade-up">
            <p className="comptitle">
              Preparation Resources
            </p>
            <p
              className="lowertitle"
              style={{
                textAlign: "center",
                marginBottom: "40px",
                maxWidth: "700px",
                margin: "0 auto 40px auto",
              }}
            >
              Participants get access to official preparation resources designed
              to help them succeed in the competition.
            </p>

            {/* Resource Cards Grid */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 300px), 1fr))",
                gap: "16px",
                maxWidth: "800px",
                margin: "0 auto",
              }}
            >
              {/* Card 1: Study Materials */}
              <div
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  padding: "20px",
                  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e8eef3",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "14px",
                  }}
                >
                  <div
                    style={{
                      width: "42px",
                      height: "42px",
                      borderRadius: "10px",
                      background:
                        "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <MenuBookIcon style={{ fontSize: "22px", color: "#fff" }} />
                  </div>
                  <div>
                    <h3
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#1a1a2e",
                        marginBottom: "6px",
                      }}
                    >
                      Study Materials
                    </h3>
                    <p
                      style={{
                        fontSize: "0.85rem",
                        color: "#666",
                        lineHeight: "1.5",
                        margin: 0,
                      }}
                    >
                      Official IRO preparation guides and curated study
                      materials covering all competition topics.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 2: Mock Exams */}
              <div
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  padding: "20px",
                  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e8eef3",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "14px",
                  }}
                >
                  <div
                    style={{
                      width: "42px",
                      height: "42px",
                      borderRadius: "10px",
                      background:
                        "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <QuizIcon style={{ fontSize: "22px", color: "#fff" }} />
                  </div>
                  <div>
                    <h3
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#1a1a2e",
                        marginBottom: "6px",
                      }}
                    >
                      Mock Exams
                    </h3>
                    <p
                      style={{
                        fontSize: "0.85rem",
                        color: "#666",
                        lineHeight: "1.5",
                        margin: 0,
                      }}
                    >
                      Practice under real competition conditions with
                      full-length mock exams and answer keys.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 3: Problem Sets */}
              <div
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  padding: "20px",
                  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e8eef3",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "14px",
                  }}
                >
                  <div
                    style={{
                      width: "42px",
                      height: "42px",
                      borderRadius: "10px",
                      background:
                        "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <ScienceIcon style={{ fontSize: "22px", color: "#fff" }} />
                  </div>
                  <div>
                    <h3
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#1a1a2e",
                        marginBottom: "6px",
                      }}
                    >
                      Problem Sets
                    </h3>
                    <p
                      style={{
                        fontSize: "0.85rem",
                        color: "#666",
                        lineHeight: "1.5",
                        margin: 0,
                      }}
                    >
                      Sample problems covering research methodology, data
                      analysis, and scientific reasoning.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 4: Competition Guide */}
              <div
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  padding: "20px",
                  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e8eef3",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "14px",
                  }}
                >
                  <div
                    style={{
                      width: "42px",
                      height: "42px",
                      borderRadius: "10px",
                      background:
                        "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <DescriptionIcon
                      style={{ fontSize: "22px", color: "#fff" }}
                    />
                  </div>
                  <div>
                    <h3
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#1a1a2e",
                        marginBottom: "6px",
                      }}
                    >
                      Competition Guide
                    </h3>
                    <p
                      style={{
                        fontSize: "0.85rem",
                        color: "#666",
                        lineHeight: "1.5",
                        margin: 0,
                      }}
                    >
                      Detailed guides explaining format, expectations, scoring
                      criteria, and success strategies.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom note */}
            <p
              style={{
                textAlign: "center",
                marginTop: "40px",
                fontSize: "15px",
                color: "#555",
                maxWidth: "650px",
                margin: "40px auto 0 auto",
              }}
            >
              All resources are provided online. Practice papers and past exams
              are freely available so you can prepare confidently and plan your
              participation.
            </p>
          </div>
        </div>

        {/* Why Should YOU Participate Section */}
        <div className="container">
          <div className="row rowpad1" data-aos="fade-up">
            <p className="comptitle">Why Should YOU Participate?</p>

            {/* Earn International Academic Honours */}
            <div style={{ marginTop: "30px", marginBottom: "40px" }}>
              <h4
                style={{
                  color: "#7d9ad4",
                  marginBottom: "10px",
                  fontSize: "22px",
                }}
              >
                Earn International Academic Honours
              </h4>
              <p className="lowertitle" style={{ marginBottom: "20px" }}>
                Unlike many competitions, IRO recognises achievement on multiple
                levels, giving students meaningful academic distinction beyond
                simply reaching the finals.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  maxWidth: "500px",
                  margin: "0 auto",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "45%",
                      backgroundColor: "#4a6fa5",
                      padding: "12px 20px",
                      borderRadius: "4px",
                      color: "white",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Top 3 — Gold, Silver, Bronze Medalists
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "60%",
                      backgroundColor: "#5a7bc4",
                      padding: "12px 20px",
                      borderRadius: "4px",
                      color: "white",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Top 12 — Finalists
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "75%",
                      backgroundColor: "#7d9ad4",
                      padding: "12px 20px",
                      borderRadius: "4px",
                      color: "white",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Top 10% — Semi-Finalists
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "90%",
                      backgroundColor: "#9db5e0",
                      padding: "12px 20px",
                      borderRadius: "4px",
                      color: "#333",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Top 20% — Distinguished Scholar
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      backgroundColor: "#c5d5ed",
                      padding: "12px 20px",
                      borderRadius: "4px",
                      color: "#333",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Top 40% — Honour Roll
                  </div>
                </div>
              </div>
            </div>

            {/* Develop Research Skills That Matter */}
            <div style={{ marginBottom: "50px" }}>
              <h4
                style={{
                  color: "#004d99",
                  marginBottom: "10px",
                  fontSize: "22px",
                  fontWeight: "600",
                }}
              >
                Develop Research Skills That Matter
              </h4>
              <p
                className="lowertitle"
                style={{
                  marginBottom: "30px",
                  maxWidth: "600px",
                  margin: "0 auto 30px auto",
                }}
              >
                Build real-world research skills including data analysis,
                critical thinking, and evidence-based reasoning.
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "24px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  maxWidth: "700px",
                  margin: "0 auto",
                }}
              >
                {/* Stat Card 1 */}
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "16px",
                    padding: "32px 36px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                    border: "1px solid #e8eef3",
                    textAlign: "center",
                    minWidth: "280px",
                    flex: "1",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      height: "4px",
                      background:
                        "linear-gradient(90deg, #004d99 0%, #0066cc 100%)",
                    }}
                  ></div>
                  <p
                    style={{
                      fontSize: "56px",
                      fontWeight: "700",
                      background:
                        "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      margin: "0 0 12px 0",
                      lineHeight: "1",
                    }}
                  >
                    71%
                  </p>
                  <p
                    style={{
                      fontSize: "15px",
                      color: "#555",
                      margin: "0",
                      lineHeight: "1.5",
                    }}
                  >
                    more likely to be accepted to a<br />
                    top 20 U.S. university
                  </p>
                </div>
                {/* Stat Card 2 */}
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "16px",
                    padding: "32px 36px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                    border: "1px solid #e8eef3",
                    textAlign: "center",
                    minWidth: "280px",
                    flex: "1",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      height: "4px",
                      background:
                        "linear-gradient(90deg, #004d99 0%, #0066cc 100%)",
                    }}
                  ></div>
                  <p
                    style={{
                      fontSize: "56px",
                      fontWeight: "700",
                      background:
                        "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      margin: "0 0 12px 0",
                      lineHeight: "1",
                    }}
                  >
                    64%
                  </p>
                  <p
                    style={{
                      fontSize: "15px",
                      color: "#555",
                      margin: "0",
                      lineHeight: "1.5",
                    }}
                  >
                    of students who do research are
                    <br />
                    accepted to a top 20 U.S. school
                  </p>
                </div>
              </div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#999",
                  textAlign: "center",
                  marginTop: "16px",
                }}
              >
                Source: Indigo Research
              </p>
            </div>

            {/* Connect With a Global Community */}
            <div style={{ marginBottom: "50px" }}>
              <h4
                style={{
                  color: "#004d99",
                  marginBottom: "10px",
                  fontSize: "22px",
                  fontWeight: "600",
                }}
              >
                Connect With a Global Community
              </h4>
              <p
                className="lowertitle"
                style={{
                  marginBottom: "30px",
                  maxWidth: "650px",
                  margin: "0 auto 30px auto",
                }}
              >
                Through IRO, students engage with peers from different
                countries, school systems, and interests, building early
                academic networks that extend beyond their classrooms.
              </p>
              <div
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  padding: "40px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                  border: "1px solid #e8eef3",
                  textAlign: "center",
                  maxWidth: "400px",
                  margin: "0 auto",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    right: "0",
                    height: "4px",
                    background:
                      "linear-gradient(90deg, #004d99 0%, #0066cc 100%)",
                  }}
                ></div>
                <p
                  style={{
                    fontSize: "72px",
                    fontWeight: "700",
                    background:
                      "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    margin: "0",
                    lineHeight: "1",
                  }}
                >
                  89+
                </p>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#1a1a2e",
                    margin: "12px 0 8px 0",
                  }}
                >
                  Countries Represented
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#666",
                    margin: "0",
                  }}
                >
                  Students from across the world competing together
                </p>
              </div>
            </div>

            {/* Discover and Deepen Your STEM Passions */}
            <div style={{ marginBottom: "20px" }}>
              <h4
                style={{
                  color: "#004d99",
                  marginBottom: "10px",
                  fontSize: "22px",
                  fontWeight: "600",
                }}
              >
                Discover and Deepen Your STEM Passions
              </h4>
              <p className="lowertitle" style={{ marginBottom: "20px" }}>
                Through IRO, explore STEM-related academic interests through
                research-driven problem solving rather than rote learning,
                building various skills along the way.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                  maxWidth: "600px",
                  margin: "0 auto",
                }}
              >
                <div>
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#333",
                      marginBottom: "8px",
                    }}
                  >
                    Develop Critical Thinking & Problem Solving
                  </p>
                  <div
                    style={{
                      width: "100%",
                      backgroundColor: "#4a6fa5",
                      borderRadius: "4px",
                      height: "24px",
                    }}
                  ></div>
                </div>
                <div>
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#333",
                      marginBottom: "8px",
                    }}
                  >
                    Encourages Innovation & Creativity
                  </p>
                  <div
                    style={{
                      width: "100%",
                      backgroundColor: "#5a7bc4",
                      borderRadius: "4px",
                      height: "24px",
                    }}
                  ></div>
                </div>
                <div>
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#333",
                      marginBottom: "8px",
                    }}
                  >
                    Enhances Confidence & Academic Clarity
                  </p>
                  <div
                    style={{
                      width: "100%",
                      backgroundColor: "#7d9ad4",
                      borderRadius: "4px",
                      height: "24px",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Master the IRO Section */}
        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "80px 0",
            marginTop: "60px",
          }}
        >
          <div className="container">
            <div data-aos="fade-up">
              <p className="comptitle" style={{ textAlign: "center" }}>
                Master the IRO
              </p>
              <p
                className="lowertitle"
                style={{
                  textAlign: "center",
                  marginBottom: "50px",
                  maxWidth: "550px",
                  margin: "0 auto 50px auto",
                }}
              >
                Prepare for success with our comprehensive resources and
                guidance.
              </p>

              {/* Resource Cards */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "24px",
                  maxWidth: "900px",
                  margin: "0 auto",
                }}
              >
                {/* Practice Exams Card */}
                <a href="/practice-exams" style={{ textDecoration: "none" }}>
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "16px",
                      padding: "32px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                      border: "1px solid #e8eef3",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      height: "100%",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 30px rgba(0, 77, 153, 0.12)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 20px rgba(0, 0, 0, 0.06)";
                    }}
                  >
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "10px",
                        background:
                          "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "20px",
                      }}
                    >
                      <QuizIcon style={{ fontSize: "24px", color: "#fff" }} />
                    </div>
                    <h3
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "600",
                        color: "#1a1a2e",
                        marginBottom: "10px",
                      }}
                    >
                      Practice Exams
                    </h3>
                    <p
                      style={{
                        fontSize: "0.95rem",
                        color: "#555",
                        lineHeight: "1.6",
                        margin: 0,
                      }}
                    >
                      Test your skills with full-length mock exams and detailed
                      answer keys.
                    </p>
                  </div>
                </a>

                {/* Curriculum Guide Card */}
                <a href="/curriculum" style={{ textDecoration: "none" }}>
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "16px",
                      padding: "32px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                      border: "1px solid #e8eef3",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      height: "100%",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 30px rgba(0, 77, 153, 0.12)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 20px rgba(0, 0, 0, 0.06)";
                    }}
                  >
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "10px",
                        background:
                          "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "20px",
                      }}
                    >
                      <MenuBookIcon
                        style={{ fontSize: "24px", color: "#fff" }}
                      />
                    </div>
                    <h3
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "600",
                        color: "#1a1a2e",
                        marginBottom: "10px",
                      }}
                    >
                      Curriculum Guide
                    </h3>
                    <p
                      style={{
                        fontSize: "0.95rem",
                        color: "#555",
                        lineHeight: "1.6",
                        margin: 0,
                      }}
                    >
                      Explore the topics and concepts covered in the IRO
                      examination.
                    </p>
                  </div>
                </a>

                {/* Student Ambassador Card */}
                <a
                  href="/forms/student-ambassador"
                  style={{ textDecoration: "none" }}
                >
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "16px",
                      padding: "32px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                      border: "1px solid #e8eef3",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      height: "100%",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 30px rgba(0, 77, 153, 0.12)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 20px rgba(0, 0, 0, 0.06)";
                    }}
                  >
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "10px",
                        background:
                          "linear-gradient(135deg, #004d99 0%, #0066cc 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "20px",
                      }}
                    >
                      <HowToRegIcon
                        style={{ fontSize: "24px", color: "#fff" }}
                      />
                    </div>
                    <h3
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "600",
                        color: "#1a1a2e",
                        marginBottom: "10px",
                      }}
                    >
                      Become an Ambassador
                    </h3>
                    <p
                      style={{
                        fontSize: "0.95rem",
                        color: "#555",
                        lineHeight: "1.6",
                        margin: 0,
                      }}
                    >
                      Join our network and help spread the word about IRO at
                      your school.
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Block of stuff */}

      </div>

      {/* Past Winners Section */}
      <div style={{ padding: "80px 0" }}>
        <div className="container">
          <div data-aos="fade-up">
            <p style={{ textAlign: "center" }} className="comptitle">
              Winners of the 2026 IRO
            </p>
            <p
              style={{
                textAlign: "center",
                maxWidth: "600px",
                margin: "0 auto 40px auto",
              }}
              className="lowertitle"
            >
              Celebrating the brightest young research minds who competed at our
              flagship finals event.
            </p>

            {/* Image with overlay card */}
            <div
              style={{
                position: "relative",
                maxWidth: "900px",
                margin: "0 auto 40px auto",
              }}
            >
              <img
                src={finals2026}
                alt="IRO Finals 2026"
                style={{
                  width: "100%",
                  height: "auto",
                  aspectRatio: "16/9",
                  objectFit: "cover",
                  borderRadius: "16px",
                  boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
                }}
              />
              {/* Overlay badge */}
              <div
                style={{
                  position: "absolute",
                  bottom: "20px",
                  left: "20px",
                  background: "rgba(255, 255, 255, 0.95)",
                  backdropFilter: "blur(10px)",
                  padding: "16px 24px",
                  borderRadius: "12px",
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                }}
              >
                <p
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: "600",
                    color: "#004d99",
                    margin: "0 0 4px 0",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                  }}
                >
                  Finals Location
                </p>
                <p
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#1a1a2e",
                    margin: 0,
                  }}
                >
                  Harvard Square, Cambridge, MA
                </p>
                <p
                  style={{
                    fontSize: "0.9rem",
                    color: "#555",
                    margin: "4px 0 0 0",
                  }}
                >
                  June 19-21, 2026
                </p>
              </div>
            </div>

            {/* Description */}
            <div
              style={{
                maxWidth: "700px",
                margin: "0 auto",
                textAlign: "center",
              }}
            >
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#555",
                  lineHeight: "1.7",
                  marginBottom: "30px",
                }}
              >
                The 2026 IRO Finals showcased some of the most promising young
                minds in the world. With its dedication to critical thinking and
                real-world application of knowledge, the IRO is shaping the next
                generation of innovative leaders who will tackle global
                challenges and make a lasting impact on society.
              </p>
              <Button
                variant="contained"
                href="/winners-hub"
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "1rem",
                  fontWeight: "600",
                  backgroundColor: "#004d99",
                  boxShadow: "0 4px 14px rgba(0, 77, 153, 0.3)",
                  "&:hover": {
                    backgroundColor: "#003d7a",
                    boxShadow: "0 6px 20px rgba(0, 77, 153, 0.4)",
                  },
                }}
              >
                View All Winners
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Board of Advisors */}
      <div className="container">
        <BoardofAdvisors />
      </div>

      {/* Partners */}
      <Partners />
    </div>
  );
}

export default Home;
